import { trace } from 'rytm-helpers'


export const initPrintShare = () => {
  document.addEventListener("click", onDocumentClick);
}

const onDocumentClick = (e) => {
  if (e.target.classList.contains("print-me")) {
    e.preventDefault();
    window.print();
  }
}